<template>
	<div class="">
		<Header></Header>
		<div class="Teachermore">
			
			<ul>
				<li v-for="(item,index) in list" :key='index' @click='yszixun(item.id)'>
					<div class="tmbg">
						<img :src="item.cover" alt="" height="91px">
					</div>
					<div class="tmtitle">
						<p>{{item.title}}</p>
					 <p>{{item.contentPart.substring(0,80)}}...</p>
					</div>
					<!-- <div class="line"></div> -->
					<div class="tmcount">
						<p>
						{{item.ctime | dateFormat}}
						</p>
					</div>
				</li>
				
			</ul>
		</div>

		<Fotter></Fotter>

	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'Zixunmore',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
               list:this.$store.state.advisoryList,
			}

		},
		methods: {
            //云师咨询
			yszixun(id){
				this.$router.push({
					path: '/ZixunDetail',
					query: {
						id: id,
					}
				
				})
			},
			
		},
		
	}
</script>

<style scoped>
	/*li列表样式可共用*/
	.Teachermore {
		width: 98%;
		margin: 20px auto;
	}

	.Teachermore ul li {
		display: inline-block;
		width: 48%;
		margin: 2px 0.1875rem;
		box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.1);
		border-radius: 7px;
		background: #fff;

	}

	/*li列表样式end*/
	.tmbg {
		width: 100%;
		height: 91px;
	}

	.tmbg img {
		width: 100%;
	}

	.tmtitle p {
		margin: 13px;
	}

	.tmtitle p:nth-child(1) {
		font-size: 14px;
		color: #333;
		font-weight: bold;
	}

	.tmtitle p:nth-child(2) {
		font-size: 14px;
		color: #333;

	}

	.line {
		width: 90%;
		height: 1px;
		background: #ccc;
		margin: 0 auto;
	}

	.tmcount {
		height: 70px;
		overflow: hidden;
		margin-top: -10px;

	}

	.tmcount p {
		font-size: 14px;
		color: #666;
		margin: 13px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Zixunmore.vue